import { createFileRoute } from "@tanstack/react-router";

import { useAuth } from "@/contexts/AuthProvider";

export const Route = createFileRoute("/_authenticated/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Dashboard</h2>
        <p className="text-muted-foreground text-sm">
          Welcome{user?.name ? `, ${user.name}` : ""}.
        </p>
      </div>
      <div className="bg-card text-card-foreground rounded-lg border p-4">
        <p className="text-muted-foreground text-sm">
          Compass is the GC Discover Engineering troubleshooting console.
        </p>
      </div>
    </div>
  );
}
